import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Delay slightly so page loads first
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem("cookie_consent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent-banner" role="dialog" aria-label="Cookie consent" className="fixed inset-x-0 bottom-0 z-[9999] animate-fade-in-up">
      <div className="bg-white border-t border-gray-200 shadow-lg">
        <div className="mx-auto max-w-7xl px-4 py-5 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex-1">
              <h3 className="text-sm font-semibold text-gray-900">We use cookies and collect data</h3>
              <p className="mt-1 text-sm leading-relaxed text-gray-600">
                We use cookies and similar technologies to enhance your experience, analyze usage, and provide personalized content. 
                By continuing to use our service, you consent to our data collection practices in compliance with the Philippines Data Privacy Act.{" "}
                <Link to="/privacy-policy" className="text-amber-600 hover:text-amber-700 underline font-medium">Read our Privacy Policy</Link> for full details.
              </p>
            </div>
            <div className="flex flex-col gap-2 sm:flex-row sm:gap-3 flex-shrink-0">
              <button
                data-testid="cookie-reject-btn"
                onClick={reject}
                className="px-4 py-2 text-sm font-medium rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Reject All
              </button>
              <button
                data-testid="cookie-accept-btn"
                onClick={accept}
                className="px-4 py-2 text-sm font-medium text-white bg-amber-500 rounded-md hover:bg-amber-600 transition-colors"
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
